var _defs, _path, _circle, _path2, _circle2, _path3, _circle3, _circle4, _path4, _circle5, _path5, _circle6, _path6, _circle7, _path7, _circle8, _path8, _circle9, _path9, _circle10, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5",
    x1: 119.27,
    y1: 42.69,
    x2: 142.26,
    y2: 42.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5",
    "data-name": "C_BG_shellbar",
    x1: 121.99,
    y1: 82.7,
    x2: 138.63,
    y2: 82.7,
    xlinkHref: "#SVGID_0_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5",
    "data-name": "C_BG_shellbar",
    x1: 121.99,
    y1: 82.7,
    x2: 138.63,
    y2: 82.7,
    xlinkHref: "#SVGID_0_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5",
    "data-name": "C_BG_shellbar",
    x1: 128.93,
    y1: 124.17,
    x2: 132.76,
    y2: 124.17,
    xlinkHref: "#SVGID_0_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5",
    "data-name": "C_BG_shellbar",
    x1: 128.93,
    y1: 124.17,
    x2: 132.76,
    y2: 124.17,
    xlinkHref: "#SVGID_0_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M133.23 60.12v3.73M133.23 102.44v3.74"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 130.73,
    cy: 41.15,
    r: 18.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5)",
    d: "M120.52 42.28l7.1 7.1 13.39-13.39"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 130.31,
    cy: 82.7,
    r: 18.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_0_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5)",
    d: "M123.24 75.63l14.14 14.14M137.38 75.63l-14.14 14.14"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 130.85,
    cy: 124.26,
    r: 18.75
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 130.85,
    cy: 124.26,
    r: 18.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M130.85 114.58v11.97"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 130.85,
    cy: 132.88,
    r: 0.88
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    stroke: "url(#SVGID_0_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5)",
    d: "M130.85 114.58v11.97"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 130.85,
    cy: 132.88,
    r: 0.88,
    stroke: "url(#SVGID_0_e2e5323c14061b9c0c40b687d07b3241e6c274091e57e18d6eb402d3fc451ca5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M79.16 61.86h24.64"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 71.5,
    cy: 61.86,
    r: 0.88
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M79.16 72.14h24.64"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 71.68,
    cy: 72.14,
    r: 0.88
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M79.16 82.41h24.64"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 71.68,
    cy: 82.41,
    r: 0.88
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M79.16 92.69h24.64"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 71.68,
    cy: 92.69,
    r: 0.88
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M113.94 132.18H58.78c-2.31 0-4.19-2.08-4.19-4.64V36.89c0-2.56 1.88-4.64 4.19-4.64h55.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundJob);
export default __webpack_public_path__ + "static/media/backgroundJob.cabaf62ecea9fcf9de60c1915a3db7a9.svg";
export { ForwardRef as ReactComponent };